import $marketAxios from "@/services/config/market-axios";

class MarketService {
  getFrontCoinScales() {
    return $marketAxios.get("market/coins-front-scales");
  }

  getPairCoinScales() {
    return $marketAxios.get("market/symbols-front-scales");
  }

  getSymbolsThumb() {
    return $marketAxios.post("/market/symbol-thumb");
  }

  getBaseSymbolsList() {
    return $marketAxios.get("/market/base-symbols-with-type/v2");
  }

  getSymbolsThumbTrend(data) {
    const { pageSize, pageNo, baseSymbol, coinSymbol } = data;
    return $marketAxios.post(
      `/market/symbol-thumb-by-base-trend/?pageSize=${pageSize}&pageNo=${pageNo}`,
      { baseSymbol, coinSymbol },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  }

  getSymbolsThumbBase(payload) {
    return $marketAxios.post(`/market/symbol-thumb-by-base`, payload, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  getPlateMini(payload) {
    return $marketAxios.post("/market/exchange-plate-mini", payload);
  }

  getSymbolInfo(payload) {
    return $marketAxios.post("/market/symbol-info", payload);
  }

  getLatestTrades(payload) {
    return $marketAxios.post("/market/latest-trade", payload);
  }

  getKLineData(payload) {
    return $marketAxios.post("/market/history", payload);
  }

  getPlateFullData(payload) {
    return $marketAxios.post(`/market/exchange-plate-full`, payload);
  }

  saveChartData({ symbol, data }) {
    return $marketAxios.post(`/market/save-chart-data?symbol=${symbol}`, data, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  getChartData(data) {
    return $marketAxios.post(`/market/restore-chart-data?symbol=${data}`);
  }
}

export default new MarketService();
